import { render, staticRenderFns } from "./AddCompanyAccountModal.vue?vue&type=template&id=4ff8dc5a&scoped=true&"
import script from "./AddCompanyAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyAccountModal.vue?vue&type=style&index=0&id=4ff8dc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8dc5a",
  null
  
)

component.options.__file = "AddCompanyAccountModal.vue"
export default component.exports